
document.addEventListener('click', function (event) {
  if (event.target.matches('button')) {
    event.target.focus()
  }
})

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

// Make iframes responsive
var iframeSelectors = '.rte iframe[src*="youtube.com/embed"]';
document.querySelectorAll(iframeSelectors).forEach(function(iframe){
  var wrapper = document.createElement('div');
  wrapper.className = 'video-wrapper';
  iframe.parentNode.insertBefore(wrapper, iframe);
  wrapper.appendChild(iframe);
  this.src = this.src;
});

/* Menu Drawer */
class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');
    const summaryElements = this.querySelectorAll('summary');
    this.addAccessibilityAttributes(summaryElements);

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('.menu-drawer__close-button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  addAccessibilityAttributes(summaryElements) {
    summaryElements.forEach(element => {
      element.setAttribute('role', 'button');
      element.setAttribute('aria-expanded', false);
      if(!element.hasAttribute('aria-controls') ){
        element.setAttribute('aria-controls', element.nextElementSibling.id);
      }
    });
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));

      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
      });
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove('menu-opening');
      this.mainDetailsToggle.querySelectorAll('details').forEach(details =>  {
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
      });
      this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
      document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(event.target)){
        this.closeMenuDrawer()
      };
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('theme-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.addEventListener('click', (event) => {
      if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
    });
    this.addEventListener('keyup', () => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
  }

  show(opener) {
    this.openedBy = opener;
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    this.querySelector('.template-popup').loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');
    button.addEventListener('click', () => {
      document.querySelector(this.getAttribute('data-modal')).show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

/* Details Modal */
class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp);
    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    const summaryElement = openDetailsElement.querySelector('summary');
    openDetailsElement.removeAttribute('open');
    summaryElement.focus();
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    })
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open')
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

/* Details Modal */
class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener(
      'keyup',
      (event) => event.code.toUpperCase() === 'ESCAPE' && this.close()
    );
    this.summaryToggle.addEventListener(
      'click',
      this.onSummaryClick.bind(this)
    );
    this.querySelector('button[type="button"]').addEventListener(
      'click',
      this.close.bind(this)
    );

    this.summaryToggle.setAttribute('role', 'button');
    this.summaryToggle.setAttribute('aria-expanded', 'false');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) && event.target.id !== 'boost-pfs-search-box-mobile'){
      this.close(false);
    }
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    this.detailsContainer.querySelector('.search__input').focus();
  }

  close(focusToggle = true) {
    this.summaryToggle.focus();
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
  }
}

customElements.define('details-modal', DetailsModal);



/* Theme Header */

/*

class StickyHeader extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.getElementById('theme-header');
    this.headerBounds = {};
    this.currentScrollTop = 0;

    this.onScrollHandler = this.onScroll.bind(this);

    window.addEventListener('scroll', this.onScrollHandler, false);

    this.createObserver();
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScrollHandler);
  }

  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });

    observer.observe(this.header);
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    
    //console.log("ScrollTop"+scrollTop);
    //console.log("Current Scroll"+this.currentScrollTop);
    //console.log("Header Bounds"+this.headerBounds.bottom);
    //console.log("Header Bounds Top"+this.headerBounds.top);

    if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      requestAnimationFrame(this.hide.bind(this));
    } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      requestAnimationFrame(this.reveal.bind(this));
    } else if (scrollTop <= this.headerBounds.top) {
      requestAnimationFrame(this.reset.bind(this));
    }

    this.currentScrollTop = scrollTop;
  }

  hide() {
    this.header.classList.add('header-hidden', 'header-sticky');
    this.closeMenuDisclosure();
    this.closeSearchModal();
    if(typeof adjustPDPNav == 'function'){
      adjustPDPNav();
    }
  }

  reveal() {
    this.header.classList.add('header-sticky', 'animate');
    this.header.classList.remove('header-hidden');
    if(typeof adjustPDPNav == 'function'){
      adjustPDPNav();
    }
  }

  reset() {
    this.header.classList.remove('header-hidden', 'header-sticky', 'animate');
    // show/hide for Safari repaint issue
    this.header.style.display = 'none';
    this.header.offsetHeight;
    this.header.style.display = 'block'
  }

  closeMenuDisclosure() {
    this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
    this.disclosures.forEach(disclosure => disclosure.close());
  }

  closeSearchModal() {
    this.searchModal = this.searchModal || this.header.querySelector('details-modal');
    this.searchModal.close(false);
  }
}

customElements.define('sticky-header', StickyHeader);

*/


document.addEventListener("DOMContentLoaded", function(event) {
  var lastGrid;
  var menuList = document.querySelectorAll(".left-col-sub li")
  for(var i=0; i<menuList.length; i++) {
    menuList[i].onmouseover = function(){
      var allMenu = document.querySelectorAll(".left-col-sub");
      for(t=0; t<allMenu.length; t++){
      var listItems = allMenu[t].querySelectorAll("li > a")
        for(j=0; j<listItems.length; j++){
          listItems[j].style.fontWeight = '400';
        }
      }
      this.classList.remove("hover");
      this.classList.add("hover");
      var collectionList =  this.closest('.sub-col-container').querySelectorAll('.collectionList li')
      var currentElement = this.querySelector('a').getAttribute('data-elementIndex');
      var curel = this.querySelector('a');
      var currentElementNum = Number(currentElement);
      this.querySelector('a').style.fontWeight = '700';
      for(var j=0; j < collectionList.length; j++) {
        collectionList[j].style.display = 'none';
        collectionList[j].classList.remove("active");
        if(currentElementNum -1  === j && curel.getAttribute('data-nolink') && collectionList[j].classList.contains('fallBackCollection') == false){
            lastGrid.style.display = 'grid'
            break
        }else if(currentElementNum -1 === j){
          collectionList[j].style.display = 'grid';
          collectionList[j].classList.add("active");
          lastGrid = collectionList[j];
        }
      }
    }
    menuList[i].onmouseout = function(){
      this.classList.remove("hover");
    }
  }

  // Locale selector
  function updateActiveLang(lang){
    $('.locales__item .locales__item-lang[href*="lang='+lang+'"]').addClass('active');
  }

  $('.locales-toggle').click(function(){
    var lang = "en";
    if(window.Weglot){
      lang = Weglot.getCurrentLang();
    }
    if($('#locale-selector').length === 0) {
      $.get('/?view=popup-locales',function(html){
        var pathUpdate = window.location.pathname + '?currency';
        $('#header-bar .header').append(html.replace(/\?currency/g,pathUpdate));
        updateActiveLang(lang);
        setTimeout(function(){
          $('#locale-selector').addClass('active');
        },20);
      });
    } else {
      $('.locales__item-lang.active').removeClass('active');
      updateActiveLang(lang);
      if($('#locale-selector').hasClass('active')){
        $('#locale-selector').removeClass('active');
      } else {
        $('#locale-selector').addClass('active');
      }
    }
  });

  $('body').on('click',function(e){
    if(($(e.target).closest('.locales').length === 0 || e.target.matches('.locales__close') || $(e.target).closest('.locales__close').length) && !e.target.matches('.locales-toggle') && $(e.target).closest('.locales-toggle').length === 0 && $('#locale-selector').hasClass('active')){
      $('#locale-selector').removeClass('active');
    }
  });
});

var topDropdownLinks = document.querySelectorAll(".summaryTopLink");
topDropdownLinks.forEach((link) => {
  link.addEventListener('click', () => {
    var allLinks = link.closest('details').querySelector('ul').querySelectorAll('.left-col-sub > li');
    allLinks.forEach((innerlink) => {
      innerlink.querySelector('a').style.fontWeight = '400'
    })
    var allGridLinks = link.closest('details').querySelector('ul').querySelectorAll('.mid-col-sub > .collectionList > li');
    allGridLinks.forEach((grid) => {
      grid.style.display = 'none';
      grid.classList.remove("active");
    })
    link.closest('details').querySelector('ul').querySelectorAll('.mid-col-sub > .collectionList > li')[0].style.display = 'grid';
    link.closest('details').querySelector('ul').querySelectorAll('.mid-col-sub > .collectionList > li')[0].classList.add("active");
    link.closest('details').querySelector('ul').querySelectorAll('.left-col-sub > li')[0].querySelector('a').style.fontWeight = '700'
  });
})

function lockScroll() {
  document.getElementById("MainContent").classList.toggle('lockScroll');
}

document.getElementById("hamburger").onclick = function() {
  lockScroll();
  element = document.getElementById("mobileQuickLinks");
  element.classList.toggle('showMobileQuickLinks');
};

/* MISC */
window.addEventListener('DOMContentLoaded', function () {
  var fancyboxJS = '<script id="fancybox-js" src="'+window.fancyboxJsUrl+'"></script>';
  var fancyboxCSS = '<link id="fancybox-styles" href="'+window.fancyboxCssUrl+'" rel="stylesheet" type="text/css" media="all" />';
  if($('[data-fancybox]').length){
    $('[data-fancybox]').one('click',function(){
      var $thisBtn = $(this);
      $('head').append(fancyboxJS + fancyboxCSS);
      var checkForFancybox = window.setInterval(function(){
        if(typeof Fancybox !== 'undefined'){
          window.clearInterval(checkForFancybox);
          $thisBtn.trigger('click');
        }
      },100);
    });
  }

  if($('.fb-hubspot-snippet').length){
    function initForm(form){
      var formid = 'form' + $(form).attr('data-id');
      var params = window[formid];
      if($('#hubspot-forms-js').length == 0){
        $('head').append('<script id="hubspot-forms-js" src="https://js.hsforms.net/forms/v2.js"></script>');
        var checkForHubspot = window.setInterval(function(){
          if(typeof hbspt !== 'undefined'){
            window.clearInterval(checkForHubspot);
            hbspt.forms.create(params);
          }
        },100);
      } else {
        hbspt.forms.create(params);
      }
    }

    const forms = document.querySelectorAll('.fb-hubspot-snippet-placeholder');
    forms.forEach((form) => {
      const handleIntersection = (entries, observer, forceLoad = false) => {
        if(!forceLoad){
          if (!entries[0].isIntersecting) return;
          observer.unobserve(form);
        }
        initForm(form);
      }
      new IntersectionObserver(handleIntersection.bind(form), {rootMargin: '500px 0px 200px 0px'}).observe(form);
    });
  }
});


/* Theme Footer */
var fAcc = document.getElementsByClassName("footer-accordion");

for (var i = 0; i < fAcc.length; i++) {
  fAcc[i].addEventListener("click", function() {
  this.classList.toggle("rotate");
  var panel = this.nextElementSibling;
  if (panel.style.maxHeight) {
    panel.style.maxHeight = null;
  } else {
    panel.style.maxHeight = panel.scrollHeight + "px";
  }
  });
}

/* CART DRAWER */
CartDrawer = (function() {

  var selectors = {
    cartDrawer: '#cart-drawer',
    cartIcon: '.header__icon--cart',
    cartCount: '.cart-count-bubble',
    cartClose: '.cart-drawer__close',
    qtyInput: '.cart-drawer__item-qty input.quantity__count',
    qtyButton: '.cart-drawer .quantity__button',
    cartSubtotal: '.cart-drawer__subtotal',
    upsellSection: '#cart-upsells--cart-drawer',
    upsells: '#cart-drawer .cart-upsells .swiper-container',
    cartStatus: '#cart-status',
    checkoutButton: '.cart-drawer__checkout'
  };

  var cache = {};

  function cacheSelectors() {
    cache = {
      $cartDrawer: $(selectors.cartDrawer),
      $cartIcon: $(selectors.cartIcon),
      $cartCount: $(selectors.cartCount),
      $cartClose: $(selectors.cartClose),
      $qtyInput: $(selectors.qtyInput),
      $qtyButton: $(selectors.qtyButton),
      $cartSubtotal: $(selectors.cartSubtotal),
      $upsellSection: $(selectors.upsellSection),
      $upsells: $(selectors.upsells),
      $cartStatus: $(selectors.cartStatus),
      $checkoutButton: $(selectors.checkoutButton)
    };
  }

  function init(){
    cacheSelectors();
    // Open cart drawer
    cache.$cartIcon.on('click.cart',function(e){
      e.preventDefault();
      renderCartDrawer(true);
    });
  }

  init();

  function initEvents() {
    // Close cart drawer
    cache.$cartClose.on('click.cart',function(){
      closeCartDrawer();
    });

    $('body').click(function(e){
      if($(e.target).hasClass('cart-drawer-open')){
        closeCartDrawer();
      }
    });

    $(window).on('resize.cart',function(){
      $('#cart-drawer').css('height',window.innerHeight + 'px');
    });

    $(document).on('keyup.cart',function(e){
      if (e.key === "Escape" && $('body').hasClass('cart-drawer-open')){
        closeCartDrawer();
        cache.$cartIcon.focus();
      }
    });

    // Item quantity changes
    $('body').on('click.qtyBtnDrawer',selectors.qtyButton,function(){
      fbQtySelectors($(this));
    });

    $('body').on('keyup','.cart-drawer__item .quantity__count',function(){
      $(this).trigger('change.qty');
    });

    $('.cart-drawer__item-remove').on('click.remove',function(){
      var changeObj = {"id": $(this).attr('data-key'), "quantity": 0};
      ajaxChange(changeObj);
    });
  }

  function ajaxChange(changeObj){
    var params = {
      url: '/cart/change.js',
      data: changeObj,
      dataType: 'json'
    };

    $.post(params).done(function(item){
      getCartContent(updateCartContent);
    }).fail(function(){
      console.error('change fail');
    });
  }

  function updateCartContent(html,show){
    unload();
    var content = $(html).find('.cart-drawer').html();
    if(typeof show !== 'undefined' && !show && $('#cart-drawer .inline-error').length){
      setTimeout(function(){
        $('.cart-drawer').html(content);
        cacheSelectors();
      initEvents();
      },3000);
    } else {
      $('.cart-drawer').html(content);
      cacheSelectors();
      initEvents();
    }
    if(!$('body').hasClass('cart-drawer-open') && (typeof show !== 'undefined' && show)){
      openCartDrawer();
    }
    getCart(updateCartCount);
    getUpsells();
    updateLiveRegion();
  }

  function updateCartCount(cart){
    cache.$cartCount.html('<span aria-hidden="true">' + cart.item_count + '</span><span class="visually-hidden">There ' + (cart.item_count == 1 ? 'is ':'are ') + cart.item_count + (cart.item_count == 1 ? '':'s') + ' in your cart.</span>');
  }

  function getCart(callback,show){
    $.getJSON('/cart.js',function(cart){
      if(typeof callback == 'function'){
        callback(cart,show);
      }
    });
  }

  function getCartContent(callback,show){
    $.get('/cart?view=drawer',function(html){
      callback(html,show);
    });
  }

  function initCartContent(html,show){
    $('body').append(html);
    $('#cart-drawer').css('height',window.innerHeight + 'px');
    cacheSelectors();
    initEvents();
    if(typeof show == 'undefined' || show){
      openCartDrawer();
      cache.$checkoutButton.focus();
    }
    getCart(updateCartCount);
    getUpsells();
    cache.$cartIcon.off('click.init');
  }

  function renderCartDrawer(show){
    if($('#cart-drawer').length == 0){
      getCartContent(initCartContent,show);
    } else {
      getCartContent(updateCartContent,show);
    }
  }

  function openCartDrawer(){
    $('body').addClass('body--overlay cart-drawer-open');
  }

  function closeCartDrawer(){
    $('body').removeClass('cart-drawer-open');
    setTimeout(function(){
      $('body').removeClass('body--overlay');
    },350); // same as css transition of cart drawer
  }

  function unload() {
    cache.$cartClose.off('click.cart');
    $('body').off('click.qtyBtnDrawer');
    $(document).off('keyup.cart');
    $(window).off('resize.cart');
  }

  function getUpsells(){
    var sectionID = cache.$upsellSection.attr('data-section-id');
    $.get(cache.$upsellSection.attr('data-url'),function(html){
      if(html !== ""){
        cache.$upsellSection.html($(html).find(selectors.upsellSection).html()).removeClass('hide');
        startSwiper('#cart-upsells-slider--'+sectionID, {
          navigation: {
            nextEl: ".cart-drawer .cart-upsells__next",
            prevEl: ".cart-drawer .cart-upsells__prev",
          },
          loop: false,
          on: {
            init: function(){
              cache.$upsellSection.addClass('slider-initialized')
            }
          }
        });
      }
    });
  }

  function updateLiveRegion() {
    cache.$cartStatus.html(window.cartStrings.updated).attr('aria-hidden', false);

    // hide content from accessibility tree after announcement
    setTimeout(function() {
      cache.$cartStatus.attr('aria-hidden', true);
    }, 1000);
  }

  return {
    renderCart: renderCartDrawer,
    closeCart: closeCartDrawer,
    unload: unload
  };
})();

var fbMaxMsgNoMore = window.cartStrings.maxQtyErrorNoMore;
var fbLoadingIcon = '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-spinner" viewBox="0 0 20 20"><path d="M7.229 1.173a9.25 9.25 0 1 0 11.655 11.412 1.25 1.25 0 1 0-2.4-.698 6.75 6.75 0 1 1-8.506-8.329 1.25 1.25 0 1 0-.75-2.385z" fill="#fff"/></svg>';
var fbUpdating = '<div id="updating-mask">'+fbLoadingIcon+'</div>';

/* Cart Change functions */
function fbAjaxChangeCallback(){
  CartDrawer.renderCart(false);
  if(window.location.pathname == '/cart'){
    $('body').trigger('cartrefresh');
    $('#updating-mask').remove();
  }
}

function fbAjaxChange(changeObj){
  var params = {
    url: '/cart/change.js',
    data: changeObj,
    dataType: 'json'
  };

  $.post(params).done(function(data){
    fbAjaxChangeCallback();
  }).fail(function(){
    console.error('change fail');
  });
}

// Quantity selectors
function fbQtySelectors($qtyButton){
  var $thisParent = $qtyButton.parent();
  var $thisQtyInput = $qtyButton.siblings('input.quantity__count');
  var qtyMin = parseInt($thisQtyInput.attr('min') || 0);
  var qtyMax = parseInt($thisQtyInput.attr('max') || null);
  var triggerChange = true;
  // setTimeout(function(){
  //   $thisParent.next('.inline-error').remove();
  // },3000);
  var currentQty = parseInt($thisQtyInput.val());
  if($qtyButton.hasClass('plus')){
    if((qtyMax !== null) && (currentQty + 1) > qtyMax){
      triggerChange = false;
      if(!$thisParent.next().hasClass('inline-error')){
        $thisParent.after('<small class="inline-error weglot-dynamic-translate">'+fbMaxMsgNoMore+'</small>');
        setTimeout(function(){
          $thisParent.next('.inline-error').remove();
        },3000);
      }
      $thisQtyInput.val(currentQty);
    } else {
      currentQty++;
    }
  } else {
    if(currentQty > qtyMin){
      currentQty--;
    } else {
      triggerChange = false;
    }
  }
  $thisQtyInput.val(currentQty);
  if(triggerChange){
    $thisQtyInput.trigger('change.qty');
  }
}

// Quantity change event
$('body').on('change.qty','input.quantity__count',function(e){
  if(e.namespace == 'qty'){
    if($(this).hasClass('cart-update')){
      $(this).attr('disabled','disabled');
      $(this).parent('.quantity').addClass('quantity--disabled');
      if(window.location.pathname == '/cart' && $(this).hasClass('cart-update')){
        $('body').append(fbUpdating);
      }
      var changeObj = {id: $(this).attr('data-key'), quantity: $(this).val()};
      fbAjaxChange(changeObj);
    }
  }
});

/* Mobile Accordian */
window.addEventListener('DOMContentLoaded', function () {
  var allTabBtns = document.querySelectorAll('.mobile-accordian__toggle');
  if (allTabBtns.length) {
    allTabBtns.forEach((button) => {
      button.addEventListener('click', function () {
        button.classList.toggle('active-mobile');
        if (button.classList.contains('active-mobile')) {
          button.nextElementSibling.style.display = "";
          button.nextElementSibling.style.maxHeight = button.nextElementSibling.scrollHeight + 'px';
        } else {
          button.nextElementSibling.style.maxHeight = '0px';
        }
      });
    });
  }
});

/* Tabbed List */
function fbTabbedListInit(){
  $('.tabbed-list__tab:nth-of-type(4n-3)').addClass('active');

  /* Added for furniture tabs */
  $('.furniture-tabs .tabbed-list__tab').removeClass('active');
  $('.furniture-tabs .tabbed-list__tab:nth-of-type(1)').addClass('active');
  
  function handleClick($t){
    var sectionID = $t.closest('.tabbed-list').attr('data-section-id');
    var tabID = $t.attr('data-tab-id');
    $('#tabbed-section-' + sectionID + ' .tabbed-list__tab').removeClass('active');
    $t.addClass('active');
    
    if(window.innerWidth > 749){
      $('#tabbed-section-' + sectionID + ' .tabbed-list__child').hide();
      $('#selection-' + sectionID + ' span').css('left', $t.offset().left - $('#tabbed-section-' + sectionID + ' .tabbed-list__tab').first().offset().left );
    }
    $('.furniture-tabs#tabbed-section-' + sectionID + ' .tabbed-list__child').hide();
    

    
    $('.tabbed-list__child[data-tab-id="' + tabID + '"]').show();
  };
  $('.mobile-accordian__toggle').click(function(){
    handleClick($(this));
  });
  $('.tabbed-list__tab').click(function(){
    handleClick($(this));
  });
}

window.addEventListener('DOMContentLoaded', function() {
  fbTabbedListInit();
});

if(Shopify.designMode){
  window.addEventListener('shopify:section:select',function(e){
    if($(e.target).closest('.tabbed-list').length){
      if($(e.target).closest('.tabbed-list').attr('data-tab-type') == 'section'){
        $('.tabbed-list__tab[data-tab-id="'+e.detail.sectionId+'"]').click();
      }
    }
  });
  window.addEventListener('shopify:block:select',function(e){
    if($(e.target).closest('.tabbed-list').length){
      if($(e.target).closest('.tabbed-list').attr('data-tab-type') == 'block'){
        $('.tabbed-list__tab[data-tab-id="'+e.detail.blockId+'"]').click();
      }
    }
  });
}
